export default () => {
  return new Promise(resolve => {

    console.log("INSIDE PROMISE");

    try {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          resolve({
            ...position.coords,
            lat: position.coords.latitude,
            lng: position.coords.longitude,
            accuracy: position.coords.accuracy
          });
        });
      }
    } catch (e) {
      console.log('GET GEOLOCATION ERROR: ', e);
    }
  });
}
